import React from "react";

const ChildProtectionPolicy = () => {
  const styles = {
    h3: {
      fontSize: "1.2rem",
      fontWeight: "bold",
      marginTop: "1.5rem",
    },
  };
  return (
    <div
      className="policy-container"
      style={{
        padding: "2rem",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
      }}
    >
      <h1>CHILD PROTECTION AND ONLINE SAFETY POLICY</h1>
      <h2>Bisleri International Pvt. Ltd.</h2>

      <h3 style={styles.h3}>1. Introduction</h3>
      <p>
        At Bisleri International Pvt. Ltd., This Child Safety and Protection
        Policy outlines our zero-tolerance approach to child sexual abuse and
        exploitation, and details the safeguards we implement to ensure that all
        interactions—whether digital, physical, or campaign-based—prioritize the
        safety, dignity, and rights of children in accordance with applicable
        Indian laws.
      </p>

      <h3 style={styles.h3}>
        2. Zero-Tolerance Policy on Child Sexual Abuse and Exploitation (CSAE)
      </h3>
      <p>
        Bisleri enforces a strict zero-tolerance policy against Child Sexual
        Abuse Material (CSAM) and any activity that constitutes CSAE. This
        includes:
      </p>
      <ul>
        <li>
          The uploading, sharing, or transmission of any content involving the
          sexual abuse or exploitation of minors.
        </li>
        <li>
          Any attempt to use the Bisleri platform for grooming, solicitation, or
          communication with minors for inappropriate purposes.
        </li>
        <li>
          The use of the application or associated platforms to facilitate
          trafficking, abuse, or exploitation of children in any form.
        </li>
      </ul>

      <h3 style={styles.h3}>3. Detection and Reporting Protocols</h3>
      <ul>
        <li>
          <strong>Automated System Protections:</strong> Application
          infrastructure is reviewed and updated to prevent misuse.
        </li>
        <li>
          <strong>User Reporting:</strong> Users may report suspicious or
          inappropriate activity to the Bisleri team.
        </li>
        <li>
          <strong>Law Enforcement Cooperation:</strong> Bisleri complies fully
          with Indian law and cooperates with authorities.
        </li>
      </ul>

      <h3 style={styles.h3}>4. Compliance with Indian Child Protection Laws</h3>
      <p>
        Bisleri adheres to all relevant Indian child safety and protection laws,
        including:
      </p>
      <ul>
        <li>
          The Protection of Children from Sexual Offences (POCSO) Act, 2012
        </li>
        <li>The Information Technology (IT) Act, 2000</li>
        <li>
          The Juvenile Justice (Care and Protection of Children) Act, 2015
        </li>
        <li>The Indian Penal Code (IPC), Sections 292–294</li>
        <li>
          Guidelines from the National Commission for Protection of Child Rights
          (NCPCR)
        </li>
      </ul>

      <h3 style={styles.h3}>5. Age-Appropriate Access and Use</h3>
      <ul>
        <li>
          <strong>User Eligibility:</strong> Designed for users 13+, with
          guidance suggested for those aged 13–18. Under 13 not permitted.
        </li>
        <li>
          <strong>Content Suitability:</strong> Content is appropriate for
          general audiences; no offensive material is hosted.
        </li>
      </ul>

      <h3 style={styles.h3}>6. Enforcement Measures</h3>
      <p>
        Accounts misusing the platform for CSAE will be suspended and reported.
        Legal action will be pursued as necessary.
      </p>

      <h3 style={styles.h3}>7. Reporting & Contact Information</h3>
      <p>
        If you have any concerns or wish to report a violation, please contact
        Bisleri support team.
      </p>

      <h3 style={styles.h3}>8. Ongoing Commitment to Online Safety</h3>
      <p>
        Bisleri is committed to regularly updating this policy in line with
        legal standards and digital safety best practices, working with child
        rights advocacy groups and national guidelines.
      </p>

      <h3 style={styles.h3}>
        9. Marketing and Advertising Guidelines Involving Minors
      </h3>
      <ul>
        <li>
          Children are portrayed respectfully and non-exploitatively in all
          marketing materials.
        </li>
        <li>
          No content encourages harmful behavior or undermines parental
          authority.
        </li>
        <li>
          Compliance with ASCI guidelines for advertising involving children.
        </li>
      </ul>

      <h3 style={styles.h3}>10. Data Privacy of Minors</h3>
      <ul>
        <li>
          Personal data of minors, if collected, follows the Digital Personal
          Data Protection Act, 2023.
        </li>
        <li>
          Explicit consent from a parent/guardian is required for any such data.
        </li>
        <li>No child-specific data is used for marketing or profiling.</li>
      </ul>

      <h3 style={styles.h3}>11. Employee and Vendor Training</h3>
      <ul>
        <li>All staff and vendors receive orientation on this policy.</li>
        <li>
          Commitment to high ethical standards in interactions involving minors
          is mandatory.
        </li>
      </ul>
    </div>
  );
};

export default ChildProtectionPolicy;
